import { render } from "./Paginador.vue?vue&type=template&id=d4f09626&scoped=true"
import script from "./Paginador.vue?vue&type=script&lang=js"
export * from "./Paginador.vue?vue&type=script&lang=js"

import "./Paginador.vue?vue&type=style&index=0&id=d4f09626&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4f09626"]])

export default __exports__